import {
	assign,
	AsyncState,
	ReduxAction,
	handleAsyncRequest,
	handleAsyncError,
	AsyncStatus,
	createAsyncState
} from '../ReduxUtils'
import {PlayerItemView} from '../../communication/PlayerApiProtocol.generated'
import {ITEMS_ERROR, TOGGLE_ITEM, REQUEST_ITEMS, RECEIVE_ITEMS} from './ItemsActions'
import {Action} from 'redux'
import { Feature, userFeatureService } from '../../services/UserFeatureService'
import { ITEM_CATEGORY } from '../../ui/profilepage/item/Items'

export interface ItemsState extends AsyncState {
    items? : PlayerItemView[];
}

let initialItems : ItemsState = createAsyncState({ items : [] })
/**
 * Reducer for AchievementState part of the application state
 * @param state
 * @param action
 * @returns {AchievementState}
 */
export function itemsReducer(state : ItemsState = initialItems, anAction : Action ) : ItemsState {
	var action : ReduxAction<any> = anAction as ReduxAction<any>
	switch (action.type) {
	case TOGGLE_ITEM:
		return assign<ItemsState>({}, state, {
			items : handleToggleItem(state.items, action.payload)
		})
	case ITEMS_ERROR:
		return handleAsyncError(state)
	case REQUEST_ITEMS:
		return handleAsyncRequest(state,action)
	case RECEIVE_ITEMS:
		let items =  (<PlayerItemView[]>action.payload)
			.filter(item => userFeatureService.doesUserHaveFeature(Feature.SWEEPS_ITEMS)
				? true
				: isGcTicketOrEntry(item) ||  isAvatar(item)
			)

		return assign<ItemsState>({}, state, {
			items : items,
			status : AsyncStatus.COMPLETED,
			lastReceived : action.createdTime
		})
	default:
		return state
	}
}

function handleToggleItem(currentState : PlayerItemView[], itemId : string) {

	let items = currentState.concat()

	for (var i = 0; i<items.length; i++) {
		if (items[i].id == itemId) {
			var equip = (items[i].equipped == false)

			for (var j = 0; j<items.length; j++) {
				if (items[j].category == items[i].category) {
					items[j] = assign<PlayerItemView>({},items[j], { equipped  : false})
				}
			}
			if (equip == true) {
				items[i] = assign({},items[i], { equipped  : true})
			}
			break
		}
	}
	return items
}

export function isGcTicketOrEntry(item: PlayerItemView): boolean {
	if (item.category !== 'TICKET' && item.category !== 'JSNG_ENTRY') return false
	if (!item.nameId) return false

	const nameId = item.nameId.toLowerCase()
	return nameId.includes('gc') || nameId.includes('xgc') || item.coinType === 'Gold'
}

export const isAvatar = (item: PlayerItemView) => item.category === 'AVATAR'
